"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContactLists = void 0;

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var fetchContactLists = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getLists,
  initiatingActionType: _actions.ContactListsActionTypes.FETCH_CONTACT_LISTS,
  requestStatusSelector: _selectors.getFetchContactListsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchContactLists
}));
exports.fetchContactLists = fetchContactLists;